module.exports = __webpack_public_path__ + "assets/img/qrcode-bilibili-5783d95b.png";